import { Map, OrderedSet } from 'immutable';

export const INITIAL_STATE = Map({
  results: OrderedSet(),
  next: undefined,
  previous: undefined,
  lastUpdate: null
});
